import React from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Modal, Dialog, Button, Text, Spacer } from '@oliasoft-open-source/react-ui-library';
import { CheckBoxList } from 'client/common/form-inputs';
import { getResolver } from 'src/validation/resolver';
import { navigateToRoute } from 'store/navigation/navigation';
import { routes } from 'views/navigation/routes/routes';
import { addKpis } from 'store/entities/campaigns/campaigns';
import { selectCompanyKpis } from 'store/entities/company-settings/selectors';
import { addKpiSchemaValidator } from 'schemas/ajv-validators';
import translations from 'src/internationalisation/translation-map.json';

const KpiModal = ({ userKpis, companyKpis, campaign, isAdding, addKpis, kpiModalUpdated, navigateToRoute }) => {
  const { t } = useTranslation();
  const { company } = useParams();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      kpis: [],
    },
    resolver: getResolver(addKpiSchemaValidator),
    mode: 'onChange',
  });

  const onClose = () => kpiModalUpdated();
  const onSubmit = handleSubmit((data) => {
    addKpis(campaign.campaignId, data);
  });

  const userKpiOptions = userKpis.filter((k) => !campaign?.kpisList.map((k) => k.id).includes(k.id));
  const companyKpiOptions = companyKpis.filter((k) => !campaign?.kpisList.map((k) => k.id).includes(k.id));

  return (
    <Modal visible centered fullScreen>
      <Dialog
        dialog={{
          width: '600px',
          heading: t(translations.campaigns_addKpis),
          content: (
            <form>
              <Text bold>{t(translations.campaigns_userKpis)}</Text>
              <CheckBoxList items={userKpiOptions || []} control={control} errors={errors} name="kpis" />
              <Text muted>{t(translations.campaigns_newKpisCanBeAddedIn)}</Text>{' '}
              <Text
                link
                onClick={() => {
                  onClose();
                  navigateToRoute(routes.userSettings.nested.kpi);
                }}
              >
                {t(translations.settings_userSettings)}
              </Text>
              <Spacer />
              <Text bold>{t(translations.campaigns_companyKpis)}</Text>
              <CheckBoxList items={companyKpiOptions || []} control={control} errors={errors} name="kpis" />
              <Text muted>{t(translations.campaigns_newKpisCanBeAddedIn)}</Text>{' '}
              <Text
                link
                onClick={() => {
                  onClose();
                  navigateToRoute(routes.companySettings.nested.kpi, {
                    company,
                  });
                }}
              >
                {t(translations.settings_companySettings)}
              </Text>
            </form>
          ),
          footer: (
            <>
              <Button label={t(translations.add)} colored onClick={onSubmit} disabled={isAdding} />
              <Button label={t(translations.cancel)} onClick={onClose} />
            </>
          ),
          onClose,
        }}
      />
    </Modal>
  );
};

const mapStateToProps = ({ entities }) => {
  const {
    settings: { kpi: userKpis },
    isAdding,
  } = entities.userSettings;
  const companyKpis = selectCompanyKpis(entities);
  return {
    userKpis,
    companyKpis,
    isAdding,
  };
};

const mapDispatchToProps = { navigateToRoute, addKpis };

const Container = connect(mapStateToProps, mapDispatchToProps)(KpiModal);

export { Container as KpiModal };
